export default __webpack_public_path__ + "static/media/8.266378de.png";